module.exports = __webpack_public_path__ + "static/media/HAYDIROKET-GLOBAL-WARNING.12092e71.JPG";